var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgRectangleWhite = function SvgRectangleWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.643,
    height: 17.957,
    viewBox: "0 0 13.643 17.957"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_210",
    "data-name": "Union 210",
    d: "M6.8,17.94Q3.4,13.463,0,8.995C1.213,7.356,2.47,5.742,3.7,4.109,4.743,2.743,5.779,1.36,6.827,0c2.285,2.976,4.54,5.982,6.816,8.968-.314.512-.738.971-1.085,1.469-1.918,2.5-3.817,5.024-5.74,7.521Z",
    fill: "#fff"
  })));
};

export { SvgRectangleWhite as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMy42NDMiIGhlaWdodD0iMTcuOTU3IiB2aWV3Qm94PSIwIDAgMTMuNjQzIDE3Ljk1NyI+CiAgPHBhdGggaWQ9IlVuaW9uXzIxMCIgZGF0YS1uYW1lPSJVbmlvbiAyMTAiIGQ9Ik02LjgsMTcuOTRRMy40LDEzLjQ2MywwLDguOTk1QzEuMjEzLDcuMzU2LDIuNDcsNS43NDIsMy43LDQuMTA5LDQuNzQzLDIuNzQzLDUuNzc5LDEuMzYsNi44MjcsMGMyLjI4NSwyLjk3Niw0LjU0LDUuOTgyLDYuODE2LDguOTY4LS4zMTQuNTEyLS43MzguOTcxLTEuMDg1LDEuNDY5LTEuOTE4LDIuNS0zLjgxNyw1LjAyNC01Ljc0LDcuNTIxWiIgZmlsbD0iI2ZmZiIvPgo8L3N2Zz4K";